export const DOCUMENTS_FOLDER = 'DOCUMENTS_FOLDER';
export const SEQUENCES_FOLDER = 'SEQUENCES_FOLDER';
export const SNIPPETS_FOLDER = 'SNIPPETS_FOLDER';
export const TEMPLATES_FOLDER = 'TEMPLATES_FOLDER';
export const PLAYBOOKS_FOLDER = 'PLAYBOOKS_FOLDER';
export const FOLDER_CONTENT_TYPES = [DOCUMENTS_FOLDER, SEQUENCES_FOLDER, SNIPPETS_FOLDER, TEMPLATES_FOLDER, PLAYBOOKS_FOLDER];